import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 z-50 w-screen overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-end justify-center text-center sm:items-center" }
const _hoisted_4 = { class: "flex justify-between items-start gap-2 sticky top-0 left-0 pt-4 sm:pt-6 bg-white lg:bg-transparent z-50" }
const _hoisted_5 = { id: "modal-content" }

import {
		ref
	} from 'vue'
	
	import {
		Dialog,
		DialogPanel,
		DialogTitle,
		TransitionChild,
		TransitionRoot
	} from '@headlessui/vue'

	/*eslint-disable*/
	
	const __default__ = { name: 'TwModal' } // name the component
  
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		blockOverlayClose: {
			type: Boolean, 
			deafult: false
		},
		description: {
			type: String,
			default: ""
		},
		modalMaxWidth: {
			type: String,
			default: 'max-w-screen-xl'
		},
		title: {
			type: String,
			default: ""
		}
	},
  emits: [
		'close'
	],
  setup(__props, { expose, emit }) {

const props = __props;

	
	

	const open = ref(false)

	function closeModal(type: string) {
		if(props.blockOverlayClose && type === 'o') {
			return
		}
		open.value = false
		emit('close')
	}

	expose({
		open
	})

return (_ctx: any,_cache: any) => {
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!

  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: open.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-50",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (closeModal('o')))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), {
                    class: _normalizeClass([__props.modalMaxWidth,'relative transform overflow-x-auto overflow-y-auto rounded-lg bg-white h-200 max-h-screen px-4 pb-4 text-left shadow-xl transition-all w-full sm:px-6 sm:pb-4'])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, [
                          _createVNode(_unref(DialogTitle), { class: "page-title capitalize" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(__props.title), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_XMarkIcon, {
                          class: "h-5 w-5 text-gray-700 hover:text-brand-500 cursor-pointer flex-none",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal('x')))
                        })
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _renderSlot(_ctx.$slots, "default")
                      ])
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})